import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Check } from 'lucide-react';
interface Tomo {
  tomo: string;
  title: string;
  subtitle: string;
  items: string[];
}
const tomos: Tomo[] = [{
  tomo: '📘 Tomo 1',
  title: '🧠 Fundamentos del Triatlón',
  subtitle: 'Cómo empezar correctamente desde cero',
  items: ['Qué es realmente el triatlón', 'Los errores que hacen abandonar a los principiantes', 'Cómo elegir tu primer objetivo', 'Sprint vs Olímpico: cuál te conviene', 'Equipamiento mínimo para empezar', 'Cómo organizar tu semana', 'Recuperación y descanso', 'Cómo evitar lesiones desde el día uno', 'Mentalidad del principiante', 'Tu hoja de ruta hacia la meta']
}, {
  tomo: '📘 Tomo 2',
  title: '🏊 Natación para Principiantes',
  subtitle: 'De sobrevivir en el agua a nadar con confianza',
  items: ['Errores más comunes', 'Respiración correcta', 'Posición corporal', 'Patada eficiente', 'Brazada eficiente', 'Cómo mejorar sin nadar más metros', 'Cómo vencer el miedo al agua abierta', 'Entrenamientos progresivos', 'Cómo medir tu progreso', 'Objetivos para tu primera carrera']
}, {
  tomo: '📘 Tomo 3',
  title: '🚴 Ciclismo para Principiantes',
  subtitle: 'Cómo construir resistencia sin destruir las piernas',
  items: ['Qué bicicleta usar', 'Posición correcta', 'Cadencia explicada fácil', 'Cómo subir resistencia', 'Cómo pedalear más eficiente', 'Errores que generan fatiga', 'Entrenamientos progresivos', 'Seguridad y técnica', 'Cómo prepararte para la transición', 'Objetivos para tu primera carrera']
}, {
  tomo: '📘 Tomo 4',
  title: '🏃 Running para Principiantes',
  subtitle: 'Cómo correr más sin lesionarte',
  items: ['Errores del corredor principiante', 'Técnica básica simplificada', 'Cómo aumentar kilómetros', 'Cómo correr sin agotarte', 'Ritmos de entrenamiento', 'Prevención de lesiones', 'Fortalecimiento complementario', 'Entrenamientos progresivos', 'Cómo correr después de pedalear', 'Objetivos para tu primera carrera']
}, {
  tomo: '📘 Tomo 5',
  title: '🔗 Cómo Unificar los 3 Deportes',
  subtitle: 'La transición de deportista a triatleta',
  items: ['Cómo se acumula la fatiga', 'Compatibilidad entre disciplinas', 'Natación + Running', 'Natación + Bicicleta', 'Bicicleta + Running', 'Primeros entrenamientos Brick', 'Cómo distribuir la semana', 'Cómo evitar el sobreentrenamiento', 'Tu primera semana completa de triatlón', 'Plan de 4 días', 'Plan de 5 días', 'Plan de 6 días']
}, {
  tomo: '📘 Tomo 6',
  title: '🏁 Dominá Tu Primer Triatlón',
  subtitle: 'Del entrenamiento a la línea de llegada',
  items: ['Cómo elegir tu primera carrera', 'Planificación de 12 semanas', 'Qué hacer el mes previo', 'Qué hacer la semana previa', 'Nutrición básica para competir', 'Hidratación', 'Transiciones paso a paso', 'Checklist del día de carrera', 'Errores comunes del debutante', 'Cómo gestionar los nervios', 'Estrategia de carrera', 'Cruzar la meta', 'Qué hacer después de tu primer triatlón']
}];
export function TomosAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto mb-20 space-y-4" data-id="element-208">
      {tomos.map((t, index) => {
      const isOpen = openIndex === index;
      return <div key={index} className={`bg-white/5 rounded-2xl border transition-colors ${isOpen ? 'border-brand-green/40' : 'border-white/10'}`} data-id="element-209">
            <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center gap-4 text-left focus:outline-none" data-id="element-210">
              <span className="text-xs font-bold tracking-widest uppercase text-brand-green flex-shrink-0" data-id="element-211">
                {t.tomo}
              </span>
              <span className="flex-1 font-bold text-base md:text-lg text-white" data-id="element-212">
                {t.title}
              </span>
              <motion.div animate={{
            rotate: isOpen ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className="flex-shrink-0 text-brand-green" data-id="element-213">
                <ChevronDown size={22} data-id="element-214" />
              </motion.div>
            </button>

            <AnimatePresence initial={false} data-id="element-215">
              {isOpen && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-216">
                  <div className="px-6 pb-6" data-id="element-217">
                    <p className="text-white/60 italic text-sm mb-5 border-l-2 border-brand-green/40 pl-3" data-id="element-218">
                      {t.subtitle}
                    </p>
                    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5" data-id="element-219">
                      {t.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-white/85 text-sm" data-id="element-220">
                          <Check size={16} className="text-brand-green flex-shrink-0 mt-0.5" data-id="element-221" />
                          <span data-id="element-222">{item}</span>
                        </li>)}
                    </ul>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}